import { Component, OnInit, EventEmitter, Output, HostBinding } from '@angular/core';

import { Observable } from 'rxjs';
import { map, filter, tap } from 'rxjs/operators';
import * as chartJs from 'chart.js';

import {
  getChartOptions,
  onResize as chartOnResize,
  plugins
} from '../../../../redux/models/invoices/chart-options.model';
import { Record, Report } from '../../../../redux/models/invoices/segments.report.model';
import { SegmentsService } from '../../../../redux/services/invoices/segments.service';
import { SegmentsReportService } from '../../../../redux/services/invoices/segments.report.service';
import { State, initialState } from '../../../../redux/reducers/invoices/reducers-segments-report';

interface IChartData {
  labels: string[];
  datasets: any[];
}

@Component({
  standalone: false,
  selector: 'app-invoices-bar-chart',
  templateUrl: './segments-bar-chart.component.html'
})
export class SegmentsBarChartComponent implements OnInit {
  @Output() hasData = new EventEmitter<boolean>();
  @HostBinding() class = 'segments-bar-chart';
  chartData$: Observable<IChartData>;
  report$: Observable<State>;
  _hasData = true;
  private chartOptions: any;
  private chart: chartJs;

  constructor(
    private readonly segmentsService: SegmentsService,
    private readonly reportService: SegmentsReportService
  ) {}

  ngOnInit() {
    const accountInvoicesChartTipUnit = $localize`:@@segments-bar-chart.accountInvoicesChartTipUnit:Segments`;
    this.chartOptions = getChartOptions(accountInvoicesChartTipUnit);
    this.report$ = this.reportService.getReport().pipe(filter(report => report !== initialState));
    this.chartData$ = this.segmentsService.getNewLoadedSegments().pipe(
      filter(state => !state.report.errorMessage),
      map(segmentsState => segmentsState.report.data),
      map(this.mapReportData.bind(this)),
      tap((data: IChartData) => {
        this._hasData = data.labels.length > 0;
        setTimeout(() => {
          this.hasData.emit(this._hasData);
          this.renderChart(data);
        });
      })
    );
  }

  private mapReportData(report: Report): IChartData {
    const labels = [];
    const data = [];
    const datasets = [];
    if (report.byDate) {
      report.byDate.forEach((record: Record) => {
        labels.push(record.date);
        data.push(record.value);
      });
      datasets.push({
        label: 'Segments',
        data,
        backgroundColor: '#005EB8',
        hoverBackgroundColor: '#005EB8'
      });
    }
    return {
      labels,
      datasets
    };
  }

  private renderChart(data: IChartData) {
    if (this.chart) {
      this.chart.destroy();
    }
    if (!this._hasData) {
      return;
    }
    const chartConfig: chartJs.ChartConfiguration = {
      type: 'bar',
      data,
      options: this.chartOptions,
      plugins
    };
    this.chart = new chartJs.Chart('invoices-bar-chart-ctx', chartConfig);
    chartOnResize(this.chart, this.chart);
    this.chart.render();
    this.chart.update();
  }
}
